import { render } from "./BasicLogin.vue?vue&type=template&id=49803696&scoped=true&ts=true"
import script from "./BasicLogin.vue?vue&type=script&lang=ts"
export * from "./BasicLogin.vue?vue&type=script&lang=ts"

import "./BasicLogin.vue?vue&type=style&index=0&id=49803696&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49803696"]])

export default __exports__